export class ActionType {
  public value = '';
  public allow = false;
}
